import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useMatch, useParams } from 'react-router';
import { EventType, Tournament } from '../../@types';
import { QUERY_KEYS } from '../../constants';
import { getData } from '../../utils/api';

export const useTournamentPage = () => {
  const { sportId, tournamentId } = useParams();
  const stackRef = useRef<HTMLDivElement>(null);

  const routeMatch = useMatch('/sports/:sportId/tournaments/:tournamentId/:section');
  const { data: tournament, isPending: isTournamentLoading } = useQuery({
    queryKey: [QUERY_KEYS.tournaments, tournamentId],

    queryFn: (): Promise<{ item: Tournament }> =>
      getData(`tournaments/${tournamentId}`, {
        page: 1,
        limit: 100,
      }),

    enabled: !!tournamentId,
    select: (data) => data.item,
    placeholderData: keepPreviousData,
  });

  const sport = tournament?.sport;
  const competition = tournament?.competition;

  useEffect(() => {
    if (stackRef.current) {
      stackRef.current.scrollTop = 0;
    }
  }, [sportId, tournamentId]);

  const eventType: EventType = routeMatch?.params.section === 'outrights' ? 'outright' : 'match';

  return {
    sportId,
    tournamentId,
    stackRef,
    tournament,
    isTournamentLoading,
    sport,
    competition,
    eventType,
  };
};
